import { __assign } from "tslib";
import { defaultBreakpoint } from '../../utils/defaults';
import { isPixelValue } from '../../utils/line-height-to-px';
import { toMobileFontSize } from '../../utils/font-utils/to-mobile-font-size';
export var buildCssMobile = function (css) {
    return "@media all and (max-width: " + defaultBreakpoint + ") {\n    .so-link-image td {width: 100%!important;}\n  }@media all and (max-width: " + defaultBreakpoint + ") {\n    " + [getMobileFontSizeCss(css), getMobileLineHeightCss(css)].join('') + "\n\n    .html-emails-button-mobile > table {\n      width: 100%!important;\n    }\n\n    .html-emails-button-empty-div-mobile {\n      display: none!important;\n    }\n\n    .PB24 .html-email-body-column > table > tbody > tr > td {\n      padding-bottom: 24px!important;\n    }\n\n    .PT24 .html-email-body-column > table > tbody > tr > td {\n      padding-top: 24px!important;\n    }\n\n    .PB24.html-email-body-column > table > tbody > tr > td {\n      padding-bottom: 24px!important;\n    }\n\n    .PT24.html-email-body-column > table > tbody > tr > td {\n      padding-top: 24px!important;\n    }\n\n    .PT16 .html-email-body-column > table > tbody > tr > td {\n      padding-top: 16px!important;\n    }\n\n    .PR16 .html-email-body-column > table > tbody > tr > td {\n      padding-right: 16px!important;\n    }\n\n    .PB16 .html-email-body-column > table > tbody > tr > td {\n      padding-bottom: 16px!important;\n    }\n\n    .PL16 .html-email-body-column > table > tbody > tr > td {\n      padding-left: 16px!important;\n    }\n\n    .PL0 .html-email-body-column > table > tbody > tr > td {\n      padding-left: 0px!important;\n    }\n\n    .PR0 .html-email-body-column > table > tbody > tr > td {\n      padding-right: 0px!important;\n    }\n\n    .MR16 > table > tbody > tr > td {\n      padding-right: 16px!important;\n    }\n\n    .ML16 > table > tbody > tr > td {\n      padding-left: 16px!important;\n    }\n  }";
};
function getMobileFontSizeCss(css) {
    var classToMobileFontSize = cssToArrayOfClassNameFontSize(css)
        .filter(function (clazz) { return !!clazz.fontSize; })
        .reduce(convertToMobileFontSize, {});
    return Object.keys(classToMobileFontSize)
        .map(function (className) {
        return "." + className + "{font-size:" + classToMobileFontSize[className] + "px!important;}";
    })
        .join('');
}
function cssToArrayOfClassNameFontSize(css) {
    return Object.keys(css).map(function (className) { return ({
        className: className,
        fontSize: css[className].fontSize,
    }); });
}
function convertToMobileFontSize(acc, _a) {
    var _b;
    var className = _a.className, fontSize = _a.fontSize;
    return __assign(__assign({}, acc), (_b = {}, _b[className] = applyCustomFontConversions(className, toMobileFontSize(fontSize)), _b));
}
function applyCustomFontConversions(className, fontSize) {
    if (className === 'so-global-footer-text' && fontSize < 14) {
        return 14;
    }
    return fontSize;
}
var fontsSizeToLineHeightRatio = 1.4;
function cssToArrayOfClassNameLineHeight(css) {
    return Object.keys(css).map(function (className) { return ({
        className: className,
        fontSize: css[className].fontSize,
        lineHeight: css[className].lineHeight,
        lineHeightRatio: css[className].originalLineHeight || fontsSizeToLineHeightRatio,
    }); });
}
function convertToMobileLineHeight(acc, _a) {
    var _b;
    var className = _a.className, fontSize = _a.fontSize, lineHeightRatio = _a.lineHeightRatio, lineHeight = _a.lineHeight;
    var ratio = isPixelValue(lineHeight) ? lineHeightRatio : lineHeight;
    return __assign(__assign({}, acc), (_b = {}, _b[className] = toMobileFontSize(fontSize) * ratio, _b));
}
function getMobileLineHeightCss(css) {
    var classToMobileLineHeight = cssToArrayOfClassNameLineHeight(css)
        .filter(function (clazz) { return !!clazz.lineHeight; })
        .reduce(convertToMobileLineHeight, {});
    return Object.keys(classToMobileLineHeight)
        .map(function (className) {
        return "." + className + "{line-height:" + classToMobileLineHeight[className] + "px!important;}";
    })
        .join('');
}
//# sourceMappingURL=build-css-mobile.js.map